import * as types from '../mutation-types'
import buildings from '../../api/buildings'

// state
export const state = {
    data: [],
    lastChanged: null,
}

// getters
export const getters = {
    mappedBuildings: (state) => {
        return state.data.filter((b) => {
            const isNullIsland = (b.lat == 0 || b.lat == null) &&
                (b.long == 0 || b.long == null);
            return !isNullIsland;
        });
    },
}

// mutations
export const mutations = {
    [types.SET_BUILDINGS](state, data) {
        var buildings = data.data
        var lastChanged = data.lastChanged

        state.data = buildings
        state.lastChanged = lastChanged
    },
}

// actions
export const actions = {
    getAllBuildings ({ commit }) {
        buildings.getBuildings((buildings, lastChanged) => {
            commit(types.SET_BUILDINGS, {'data': buildings, 'lastChanged': lastChanged})
        })
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/buildings.js